(function($) {
	
	$(document).ready(function() {
	
		$('.tab_trigger').on('click touch', function(e) {
			
			e.preventDefault();
			e.stopPropagation();
			
			$('.tab').removeClass('active');
			$($(this).data('target')).addClass('active');
			
			return false;
			
		});
		
	});
	
})(jQuery);